import { useState } from 'react';

import { motion } from 'framer-motion';

const ITEMS = [
  { label: 'Facts', textStyles: 'text-blue-950 z-30', boxStyles: 'border-blue-400 bg-blue-100' },
  { label: 'Chunks', textStyles: 'text-orange-950 z-20', boxStyles: 'border-orange-400 bg-orange-100' },
  { label: 'Documents', textStyles: 'text-purple-950 z-10', boxStyles: 'border-purple-400 bg-purple-100' },
] as const;

export function ReferenceKey() {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="absolute top-2 right-0 z-10 flex cursor-default overflow-hidden rounded-lg bg-gray-50 p-1.5 text-xs"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {ITEMS.map((item, i) => (
        <motion.div
          key={item.label}
          className={`flex items-center ${item.textStyles}`}
          animate={{
            marginLeft: hovered ? 12 : i === 0 ? 0 : -12,
          }}
          transition={{ type: 'spring', stiffness: 800, damping: 80 }}
        >
          <div className={`size-3.75 rounded border ${item.boxStyles}`} />
          <motion.span
            className="-mb-px ml-1.5 whitespace-nowrap"
            animate={{ opacity: hovered ? 1 : 0, width: hovered ? 'auto' : 0 }}
            transition={{ duration: 0.15 }}
          >
            {item.label}
          </motion.span>
        </motion.div>
      ))}
    </div>
  );
}
